import { useEffect, useMemo } from 'react'

import { WalletIcon } from '@/components/tokens/WalletIcon'
import { Button } from '@/components/ui/button'
import { Dropdown } from '@/components/ui/dropdown-menu'
import { Text } from '@/components/ui/text'
import { useConnectedWalletHistory, useWallet } from '@/hooks'
import { useReferralActions, useReferralWalletOption, WalletOption } from '@/store'
import { truncateAddress } from '@/utils'

import { isEmpty } from 'lodash-es'

const renderWalletOption = (option: WalletOption) => {
  if (isEmpty(option)) return null
  return (
    <div className='flex items-center gap-2'>
      <WalletIcon wallet={option.wallet.wallet} className='size-5' />
      <Text>{truncateAddress(option.label)}</Text>
    </div>
  )
}

export const WalletSelector = () => {
  const { wallets } = useWallet()
  const { setReferralWallet } = useReferralActions()
  const { lastedConnectedWallet } = useConnectedWalletHistory()
  const walletSelected = useReferralWalletOption()
  const walletOptions = useMemo(() => {
    if (isEmpty(wallets)) return []
    const options = Object.keys(wallets)
      .filter((wl) => wallets[wl].isConnected)
      .map((wl) => ({
        label: wallets[wl].address,
        value: wallets[wl].address,
        wallet: wallets[wl],
      }))

    if (isEmpty(options)) return []
    return options
  }, [wallets]) as WalletOption[]

  useEffect(() => {
    const currentWallet = walletOptions.find((option) => option.wallet.address === walletSelected?.value)
    if (currentWallet) return
    const wallet =
      walletOptions.find((option) => option.wallet.address === lastedConnectedWallet?.address) || walletOptions[0]
    setReferralWallet(wallet)
  }, [walletOptions])

  if (walletOptions.length === 1) {
    return (
      <Button variant='secondary' size='sm' className='px-2'>
        {renderWalletOption(walletOptions[0])}
      </Button>
    )
  }
  return (
    <Dropdown
      data={walletOptions}
      itemRender={renderWalletOption}
      labelRender={renderWalletOption}
      onChange={(option) => {
        setReferralWallet(option)
      }}
      value={walletSelected as WalletOption}
      triggerSize='sm'
      contentClassname='w-[173px]'
      triggerClassname='!px-2'
    />
  )
}
